import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/display.css'
import '@/assets/css/jiu97.css'
import '@/assets/css/default.css'
import router from '@/router'
import store from '@/store'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import Icon from '@/components/ui-icon'
import * as elIcons from '@element-plus/icons-vue'
import request from '@/utils/request'
import VueUeditorWrap from 'vue-ueditor-wrap'
import App from './App.vue'
// import socket from './utils/socket'

const app = createApp(App)
    .use(router)
    .use(store)
    .use(request)
    .use(VueUeditorWrap)
    .use(ElementPlus, {
        locale: zhCn
    })
    // .use(socket)
    .component('ui-icon', Icon)

for (let icon in elIcons) {
    app.component(`ElIcon${icon}`, elIcons[icon])
}

app.config.warnHandler = () => null
app.mount('#app')
